module.exports = __webpack_public_path__ + "img/default.6a2e3532.jpg";